export default "__VITE_ASSET__D7Vu9hg3__"